export function deepClone<T>(source: T): T {
  if (!source) return source;
  return JSON.parse(JSON.stringify(source));
}
